/**
 * @file automatically generated from MApp.Data.ImageryServiceType
 */

export enum ImageryServiceType {
    Wms = 1,
    Wmts = 2,
    Ecwp = 4
}
